<template>
    <v-app>
        <Header/>
        <transition name="fade" mode="out-in">
            <router-view/>
        </transition>
        <Footer/>
    </v-app>
</template>

<script>
    import Header from "@/components/base/default/Header";
    import Footer from "@/components/base/default/Footer";

    export default {
        name: "masterDefault",
        components: {
            Header,
            Footer,
        },
        data: () => ({
            //
        }),
    };
</script>
